import { mainContent, rirekishoContent } from '@src/constants/path_list';
import type { RouterPath } from '@src/constants/router_path';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * コンテンツタイプ
 */
type ContentType = 'resume' | 'rirekisho';

/**
 * ページ情報の型
 */
export interface PageInfo {
  currentIndex: number;
  currentPath: RouterPath;
  isFirst: boolean;
  isLast: boolean;
  totalPages: number;
  currentPage: number;
  currentName: string;
  currentPageTitle?: string;
  prevPath: RouterPath | null;
  nextPath: RouterPath | null;
}

/**
 * ControlAreaのナビゲーションロジックを提供するカスタムフック
 *
 * @param contentType - コンテンツタイプ ('resume' または 'rirekisho')
 * @returns ページ情報
 */
export function useControlAreaNavigation(contentType: ContentType = 'resume'): PageInfo | null {
  const location = useLocation();

  const pageInfo = useMemo(() => {
    const currentPath = location.pathname as RouterPath;
    const contentList = contentType === 'rirekisho' ? rirekishoContent : mainContent;
    const currentIndex = contentList.findIndex((item) => item.path === currentPath);

    if (currentIndex === -1) {
      return null;
    }

    return {
      currentIndex,
      currentPath,
      isFirst: currentIndex === 0,
      isLast: currentIndex === contentList.length - 1,
      totalPages: contentList.length,
      currentPage: currentIndex + 1,
      currentName: contentList[currentIndex].name,
      currentPageTitle: contentList[currentIndex].pageTitle,
      prevPath: (currentIndex > 0 ? contentList[currentIndex - 1].path : null) as RouterPath | null,
      nextPath: (currentIndex < contentList.length - 1
        ? contentList[currentIndex + 1].path
        : null) as RouterPath | null,
    };
  }, [location.pathname, contentType]);

  return pageInfo;
}
